import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKeyboardDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="keyboard-down"><path d="M10 19L12 21L14 19M9.75 11.25H14.25M1.75 2.75H22.25V15.25H1.75V2.75ZM5.75 6.75H5.76V6.76H5.75V6.75ZM9.75 6.75H9.76V6.76H9.75V6.75ZM14.25 6.75H14.26V6.76H14.25V6.75ZM5.75 11.25H5.76V11.26H5.75V11.25ZM18.25 6.75H18.26V6.76H18.25V6.75ZM18.25 11.25H18.26V11.26H18.25V11.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconKeyboardDown;
